module.exports = __webpack_public_path__ + "media/images/pt/welcome_leadership-aaf2ca6234bb2b48d2025627b642f269.png";